module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/error-484f75c555f483226a31109725bd8b5d.svg";